import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const FAQValidationSchema = z.object({
  question: z
    .string()
    .min(1, { message: "Question is required." })
    .transform((val) => val.trim()),
  answer: z
    .string()
    .min(1, { message: "Answer is required." })
    .transform((val) => val.trim()),
  category_id: z.string().refine((value) => isValidId(value), {
    message: "Category must be a valid ObjectId.",
  }),
  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),
});
